module.exports = {
      id: "fb-usage",
      viewBox: "0 0 20 20",
      url: "/" + "sprite-830c6fc89c6e575b53718d760c90aee8.svg#fb",
      toString: function () {
        return this.url;
      }
    }